(() => {
  if (window.__expoPriceGuardBootstrapped) return;
  window.__expoPriceGuardBootstrapped = true;

  const INIT_FLAG = 'expoPriceGuardInitialized';

  const isVisible = (element) => {
    if (!element || !element.isConnected || element.hidden) return false;

    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse') return false;
    if (parseFloat(style.opacity) === 0) return false;

    return element.getClientRects().length > 0;
  };

  const hasVisibleExpoSection = (productInfo) => {
    const expoSection = productInfo.querySelector('#expo-section');
    return isVisible(expoSection);
  };

  const hasExpoPriceMarkup = (priceContainer) => {
    return Boolean(priceContainer.querySelector('.price.expo-changed'));
  };

  const createGuard = (productInfo) => {
    if (!(productInfo instanceof HTMLElement)) return;
    if (productInfo.dataset[INIT_FLAG] === 'true') return;
    productInfo.dataset[INIT_FLAG] = 'true';

    const sectionId = productInfo.dataset.section;
    if (!sectionId) return;

    const priceContainer = productInfo.querySelector(`#price-${sectionId}`);
    if (!priceContainer) return;

    let shopifySnapshot = priceContainer.innerHTML;
    let isRestoring = false;
    let syncScheduled = false;

    const scheduleSync = () => {
      if (syncScheduled) return;
      syncScheduled = true;

      window.requestAnimationFrame(() => {
        syncScheduled = false;
        syncPriceState();
      });
    };

    const restoreSnapshot = () => {
      if (!shopifySnapshot || isRestoring) return;
      isRestoring = true;
      priceContainer.innerHTML = shopifySnapshot;

      window.requestAnimationFrame(() => {
        isRestoring = false;
      });
    };

    const syncPriceState = () => {
      if (!priceContainer.isConnected || isRestoring) return;

      if (!hasExpoPriceMarkup(priceContainer)) {
        shopifySnapshot = priceContainer.innerHTML;
        return;
      }

      if (!hasVisibleExpoSection(productInfo)) {
        restoreSnapshot();
      }
    };

    new MutationObserver(scheduleSync).observe(priceContainer, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    // Watch expo visibility changes so hidden Expo cannot keep controlling the price.
    new MutationObserver(scheduleSync).observe(productInfo, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
    });

    syncPriceState();
  };

  const init = (root = document) => {
    root.querySelectorAll("product-info[id^='MainProduct-']").forEach(createGuard);
  };

  document.addEventListener('product-info:loaded', (event) => {
    const productInfo = event.target.closest?.("product-info[id^='MainProduct-']");
    if (productInfo) createGuard(productInfo);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
})();
